import { API_BASE_URL, API_TOKEN } from '../config/apiConfig';
import React, { useState, useEffect, useRef } from "react";
import Header from "./layout/Header";
import Footer from "./layout/Footer";
import { NavLink, useNavigate } from "react-router-dom";
// import store from "../store/store";
// import print from "print-js";
import "../css/t-care.css";
// import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css/free-mode";
import "swiper/css";
import "swiper/css/navigation";
// import { Navigation } from "swiper/modules";
import axios from "axios";
import "toastr/build/toastr.min.css"; // Import toastr CSS
import toastr from "toastr";
import { Oval } from "react-loader-spinner";
// import PrivacyPolicy from './PrivacyPolicy'; // Pastikan jalur ini sesuai dengan lokasi file PrivacyPolicy.js Anda
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
// import Slider from "react-slick";
import StickyExploreButton from "./components/StickyExploreButton";
import StickyLeftButton from "./components/StickyLeftButton";
import AftersalesExploreService from "./components/AftersalesExploreService";

function EVHC() {
  const navigate = useNavigate();
  const pdfRef = useRef(null);

  const [downloadWarranty, setDownloadWarranty] = useState(null);
  const [downloadCoating, setDownloadCoating] = useState(null);
  const [downloadAbility, setDownloadAbility] = useState(false);
  const [loading, setLoading] = useState(false);
  const [downloadCertificate, setDownloadCertificate] = useState(null);
  const [download, setDownload] = useState(null);
  // const [ type, setType ] = useState( 1 );
  const [vin, setVinInput] = useState("");
  const [imageUrl, setImageUrl] = useState("");
  const [imageUrl2, setImageUrl2] = useState("");
  const [message, setmessage] = useState("");
  const [description, setDescription] = useState("");
  const [kendaraan, setkendaraan] = useState("");
  const [warna, setwarna] = useState("");
  // const [ hidebutton, sethidebutton ] = useState( 0 );
  const [guideline, setguideline] = useState("");
  const [tagline, settagline] = useState("");
  const [color, setcolor] = useState("");
  const [product, setproduct] = useState("");
  const [submission, setsubmission] = useState("");
  const [potentialDataSubmission, setPotentialDataSubmission] = useState("");
  const [programName, setprogramname] = useState("");
  const [info, setinfo] = useState("");
  const [timerValue, setTimerValue] = useState(60); // Initialize timer value
  const [uname, setName] = useState("");
  const [uemail, setEmail] = useState("");
  const [isEmailChanged, setIsEmailChanged] = useState(false);
  const [hasOldEmail, setHasOldEmail] = useState(false);
  const [oldEmail, setOldEmail] = useState("");
  const [register, setregister] = useState();
  const [tableData, settableData] = useState([]);
  const [tableDataCoating, settableDataCoating] = useState([]);
  const [checkServiceNmae, setCheckServiceName] = useState("");
  const [checkSeriveModel, setCheckserviceModel] = useState("");
  const [otp1, setOtp1] = useState("");
  const [otp2, setOtp2] = useState("");
  const [otp3, setOtp3] = useState("");
  const [otp4, setOtp4] = useState("");
  const [otp5, setOtp5] = useState("");
  const [otp6, setOtp6] = useState("");
  const [WrongVin, setWrongVin] = useState("");
  // const [ checkemptyfield, setcheckemptyfield ] = useState( false );
  // const [ isChecked1, setIsChecked1 ] = useState( false );
  const [ isChecked2, setIsChecked2 ] = useState( false );
  // const [ showModal, setShowModal ] = useState( false );
  // const [ showInfoMenu, setShowInfoMenu ] = useState( true );
  const [showCertificateMenu, setShowCertificateMenu] = useState(true);
  const [showServiceHistoryMenu, setShowServiceHistoryMenu] = useState(false);
  // const [ expandedRows, setExpandedRows ] = useState( [] );
  // const [ isTableVisible, setIsTableVisible ] = useState( false );
  // const [ isTableVisibleCoating, setIsTableVisibleCoating ] = useState( false );
  const [selectedMonth, setSelectedMonth] = useState("");
  const [activeTab, setActiveTab] = useState(0);
  // const [ activeTab1, setActiveTab1 ] = useState( 0 );
  const [secondtab, setsecondtab] = useState(0);
  const [selectedYear, setSelectedYear] = useState("");
  // const [ vinn, setVinn ] = useState( "" );
  const [emaill, setEmaill] = useState("");
  // const [ Nodata, setNodata ] = useState( "" );
  const [serviceHistoryProgram, setServiceHistoryProgram] = useState("");
  const [Active_tab1, setActive_tab1] = useState(1);


  const handleInputChange = (event) => {
    setVinInput(event.target.value);
    setWrongVin("");
  };

  const handleTabClick = (index) => {
    setActiveTab(index);
  };

  const handleCheckbox2Change = () =>
  {
    setIsChecked2( !isChecked2 );
  };

  // const handleTabClick1 = ( index ) =>
  // {
  //   setActiveTab1( index ); // Set the active tab
  //   if ( index == 0 )
  //   {
  //     setDownload( downloadCertificate );
  //     setType( 1 );
  //   }

  //   setActiveTab1( index ); // Set the active tab
  //   if ( index == 1 )
  //   {
  //     setDownload( downloadWarranty );
  //     setType( 2 );
  //   }

  //   setActiveTab1( index ); // Set the active tab
  //   if ( index == 2 )
  //   {
  //     setDownload( downloadCoating );
  //     setType( 3 );
  //   }
  // };

  // const handleHHCMainTab = ( target ) =>
  // {
  //   if(target === 'certificate'){
  //     setShowInfoMenu(false);
  //     setShowCertificateMenu(true);
  //   }
  //   else{
  //     setShowCertificateMenu(false);
  //     setShowInfoMenu(true);
  //   }
  // };

  const handleregister = (valueChannge) => {

    if (valueChannge === 3) {
      setEmail(oldEmail || "");
      setIsEmailChanged(true);
    }

    setsecondtab(valueChannge);
  };

  const goBack = (index1) => {
    // setActive_tab1( index1 );
    // if(index1 == 1){
    //   setVinInput("");
    //   setEmaill("");
    // }
    window.location.reload();
  };

  const handleLanjutClick = async () => {
    setLoading(true);
    setDownloadWarranty("");
    setDownloadCoating("");
    setDownloadCertificate("");
    setDownload("");
    setName("");
    setEmail("");
    setOldEmail("");
    setHasOldEmail(false);
    setIsEmailChanged(false);
    setDownloadAbility(true);
    setPotentialDataSubmission("");

    if (vin.length < 1) {
      toastr.error("Enter the Vin");
      setLoading(false);
      return;
    }
    try {
      const response = await axios.post(
        `${API_BASE_URL}/check-hhc-vin`,
        {
          vin,
          origin: 'hybrid_health_check'
        },
        {
          headers: {
            Authorization: `Bearer ${API_TOKEN}`,
          },
        }
      );

      if (
        response &&
        response.data &&
        response.data.data &&
        response.data.data.color
      ) {
        setcolor(response.data.data.color);
        setproduct(response.data.data.color);
        setproduct(response.data.data.color);
        setImageUrl(response.data.imgUrl);
        setImageUrl2(response.data.imgUrl2);
        settagline(response.data.tagline);
        setDescription(response.data.description);
        setsubmission(response.data.submission);
        setPotentialDataSubmission(response.data.potential_data_submission);
        setprogramname(response.data.program_name);
        setinfo(response.data.info);
        setguideline(response.data.tagline);
        setName(response.data.data.name);
        setEmail(response.data.data.email);
        setOldEmail(response.data.data.email);
        setDownloadCertificate(response.data.download_certificate);
        setDownloadWarranty(response.data.download_warranty);
        setDownloadCoating(response.data.download_coating);
        setDownload(response.data.download_certificate);
        // if ( response.data.download_warranty == null )
        // {
        //   sethidebutton( 1 );
        // } else
        // {
        //   sethidebutton( 0 );
        // }

        if (response.data.data) {
          setHasOldEmail(true);
        }

        setLoading(false);
        setsecondtab(2);
        setregister(2);
      } else {
        setLoading(false);

        setImageUrl(response.data.imgUrl);
        setImageUrl2(response.data.imgUrl2);
        settagline(response.data.tagline);
        setguideline(response.data.guideline);
        setVinInput(response.data.vin);
        setmessage(response.data.message);
        setDescription(response.data.description);
        toastr.error(response.data.status);
        setLoading(false);
        setsecondtab(1);
        setregister(2);
      }

      // setActiveCircle(activeCircle + 1);
    } catch (error) {
      // Handle error here
      setLoading(false);
      if (error.response) {
        if (error.response.data.message == "Server Error") {
          toastr.error("Kendaraan tidak terdaftar.");
          setWrongVin("");
        } else {
          toastr.error(error.response.data.message);
          setWrongVin(error.response.data.message);
        }
      } else {
        toastr.error("Kendaraan tidak terdaftar.");
      }
      // setsecondtab(1);
      setregister(1);
    }
  };



  useEffect(() => {
    const currentYear = new Date().getFullYear(); // Get the current year
    const years = Array.from(
      { length: currentYear - 1999 },
      (_, index) => 2000 + index
    ); // Create an array of years from 2000 to the current year
    setSelectedYear(currentYear.toString()); // Set the default selected year to the current year
  }, []);


  const handleMonthChange = (e) => {
    setSelectedMonth(e.target.value); // "1".."12"
  };

  const handleYearChange = (e) => {
    setSelectedYear(e.target.value);
  };


  const monthMap = {
    Month: "",
    January: "1",
    February: "2",
    March: "3",
    April: "4",
    May: "5",
    June: "6",
    July: "7",
    August: "8",
    September: "9",
    October: "10",
    November: "11",
    December: "12",
  };

  const monthList = [
    "January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"
  ];

  const monthOptions = [
    { label: "January", value: "1" },
    { label: "February", value: "2" },
    { label: "March", value: "3" },
    { label: "April", value: "4" },
    { label: "May", value: "5" },
    { label: "June", value: "6" },
    { label: "July", value: "7" },
    { label: "August", value: "8" },
    { label: "September", value: "9" },
    { label: "October", value: "10" },
    { label: "November", value: "11" },
    { label: "December", value: "12" },
  ];


  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  const submitData = async () => {
    setLoading(true);

    if (uname.length < 1) {
      toastr.error("Name is required");
      setLoading(false);
      return;
    }
    if (!hasOldEmail || isEmailChanged) {
      if (!uemail.trim()) {
        toastr.error("Email is required");
        setLoading(false);
        return;
      }
      if (!emailRegex.test(uemail)) {
        toastr.error("Invalid email format");
        setLoading(false);
        return;
      }
    }
    if (!selectedMonth) { // cukup cek empty
      toastr.error("Month is required");
      setLoading(false);
      return;
    }
    if (!selectedYear) {
      toastr.error("Year is required");
      setLoading(false);
      return;
    }

    try {
      const payload = {
        vin,
        name: uname,
        email: uemail,
        buy_month: selectedMonth,
        buy_year: selectedYear,
        origin: 'hybrid_health_check'
      };
      if (!hasOldEmail || isEmailChanged) payload.email = uemail;

      const response = await axios.post(`${API_BASE_URL}/submitData`, payload, {
        headers: { Authorization: `Bearer ${API_TOKEN}` },
      });

      setkendaraan(response.data.kendaraan);
      setName(response.data.name);
      setEmail(response.data.email);
      setEmail(response.data.email);
      setOldEmail(response.data.email);
      setHasOldEmail(true);
      setIsEmailChanged(false);
      setVinInput(response.data.vin);
      setwarna(response.data.warna);

      // pastikan isi ulang konsisten → string angka
      setSelectedYear(String(response.data.buy_year));
      setSelectedMonth(String(response.data.buy_month));

      setLoading(false);
      setsecondtab(4);
    } catch (error) {
      setLoading(false);
      if (error.response) toastr.error(error.response.data.message);
    }
  };

  const submitRegister = async () => {
    setLoading(true);

    if (!hasOldEmail || isEmailChanged) {
      if (!uemail.trim()) {
        toastr.error("Email is required");
        setLoading(false);
        return;
      }
      if (!emailRegex.test(uemail)) {
        toastr.error("Invalid email format");
        setLoading(false);
        return;
      }
    }

    try {
      const payload = {
        vin,
        name: uname,
        buy_month: selectedMonth,
        email: uemail,
        buy_year: selectedYear,
        origin: 'hybrid_health_check',
        ...(!hasOldEmail || isEmailChanged ? { email: uemail } : {}),
      };
      if (!hasOldEmail || isEmailChanged) payload.email = uemail;

      const response = await axios.post(`${API_BASE_URL}/submitRegister`, payload, {
        headers: { Authorization: `Bearer ${API_TOKEN}` },
      });

      setLoading(false);
      setsecondtab(5);
      setTimerValue(60);
      countdown();
    } catch (error) {
      setLoading(false);
      if (error.response) toastr.error(error.response.data.message);
    }
  };

  const submitOtp = async () => {
    setLoading(true);
    // const selectedMonthValue = monthMap[ selectedMonth ];
    const otp = otp1 + otp2 + otp3 + otp4 + otp5 + otp6;
    setOtp1(""); // Empty the value of otp1
    setOtp2(""); // Empty the value of otp2
    setOtp3(""); // Empty the value of otp3
    setOtp4(""); // Empty the value of otp4
    setOtp5(""); // Empty the value of otp5
    setOtp6("");
    setDownloadAbility(true);
    setsubmission("");

    try {
      const response = await axios.post(
        `${API_BASE_URL}/submitOtp`,
        {
          otp,
          vin,
          origin: 'hybrid_health_check'
        },
        {
          headers: {
            Authorization: `Bearer ${API_TOKEN}`,
          },
        }
      );

      // setDownloadWarranty( response.data.download_warranty );
      // setDownloadCoating( response.data.download_coating );
      // setDownloadCertificate( response.data.download_certificate );
      // setDownload( response.data.download_certificate );
      // setDownloadAbility(response.data.certificate_download_ability);
      // setsubmission( response.data.submission );
      // setprogramname( response.data.program_name );


      if (response.data.vin) {
        setsecondtab(6);
      }

      setShowCertificateMenu(true);
      setShowServiceHistoryMenu(false);
      setLoading(false);

      // if ( response.data.download_warranty == null )
      // {
      //   sethidebutton( 1 );
      // } else
      // {
      //   sethidebutton( 0 );
      // }
    } catch (error) {
      setLoading(false);
      toastr.error(error.response.data.message);
      setOtp1(""); // Empty the value of otp1
      setOtp2(""); // Empty the value of otp2
      setOtp3(""); // Empty the value of otp3
      setOtp4(""); // Empty the value of otp4
      setOtp5(""); // Empty the value of otp5
      setOtp6("");
    }
  };

  const countdown = () => {
    let intervalId;
    const startTimer = () => {
      intervalId = setInterval(() => {
        setTimerValue((prevTimerValue) => {
          if (prevTimerValue === 0) {
            clearInterval(intervalId);
            return 0; // Reset timer to 60 seconds
          }
          return prevTimerValue - 1;
        });
      }, 1000);
    };

    // Start the timer initially
    startTimer();

    // Clean up the timer on component unmount
    return () => clearInterval(intervalId);
  };

  // const sendEmail = async () =>
  // {
  //   setLoading( true );
  //   try
  //   {
  //     const response = await axios.post(
  //       `${ API_BASE_URL }/sendEmail`,
  //       {
  //         vin,
  //         type,
  //         origin: 'hybrid_health_check'
  //       },
  //       {
  //         headers: {
  //           Authorization: `Bearer ${ API_TOKEN }`,
  //         },
  //       }
  //     );

  //     toastr.success( response.data.message );
  //     setLoading( false );
  //   } catch ( error )
  //   {
  //     setLoading( false );
  //     toastr.error( error.response.data.message );
  //   }
  // };

  // const handleDownload = async () =>
  // {
  //   if ( !download )
  //   {
  //     toastr.error( "No PDF data available for download" );
  //     return;
  //   }
  //   try
  //   {
  //     // Create a link element
  //     var link = document.createElement( "a" );

  //     // Set the href attribute of the link to the PDF file URL
  //     link.href = download;
  //     link.setAttribute( "target", "_blank" );

  //     // Set the download attribute to force download the PDF file
  //     link.setAttribute( "download", "downloaded_" + vin + ".pdf" );

  //     // Append the link to the body
  //     document.body.appendChild( link );

  //     // Trigger a click event on the link
  //     link.click();

  //     // Remove the link from the DOM after triggering download
  //     document.body.removeChild( link );

  //     // // Fetch the PDF file using the PDF URL
  //     // const response = await axios.get(download, { responseType: "blob" });

  //     // // Create a Blob from the response data
  //     // const blob = new Blob([response.data], { type: "application/pdf" });

  //     // // Create a URL for the Blob
  //     // const url = URL.createObjectURL(blob);

  //     // // Create a link element
  //     // const link = document.createElement("a");

  //     // // Set the href attribute of the link to the URL of the Blob
  //     // link.href = url;

  //     // // Set the download attribute to specify the filename
  //     // link.download = "downloaded_file.pdf";

  //     // // Simulate a click on the link to trigger the download
  //     // link.click();
  //     // // Clean up by revoking the URL object
  //     // URL.revokeObjectURL(url);
  //   } catch ( error ) { }
  // };

  // const handlePrint = () =>
  // {
  //   // store.dispatch({ type: 'SET_PRINT_URL', payload: { download } });
  //   localStorage.setItem( 'printUrl', download );

  //   const newTab = window.open( '/print', '_blank' );
  //   if ( newTab )
  //   {
  //     newTab.focus(); // Focus on the new tab
  //   } else
  //   {
  //     toastr.error( 'Try again later' )
  //   }

  // };

  const handleServiceHistory = async () => {
    setShowServiceHistoryMenu(false)
    setLoading(true);
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const email = emaill;
    if (email.trim() == "") {
      toastr.error("Email is required");
      setLoading(false);
      setShowServiceHistoryMenu(true)
      return;
    }
    if (!emailRegex.test(email)) {
      toastr.error("Invalid email format");
      setLoading(false);
      setShowServiceHistoryMenu(true)
      return;
    }

    try {
      const response = await axios.post(
        `${API_BASE_URL}/serviceHistory`,
        {
          vin,
          email,
          origin: 'hybrid_health_check'
        },
        {
          headers: {
            Authorization: `Bearer ${API_TOKEN}`,
          },
        }
      );

      if (response.data.message == "success.") {
        settableData(response.data.data);
        settableDataCoating(response.data.coating);
        setCheckServiceName(response.data.name);
        setCheckserviceModel(response.data.model);
        setServiceHistoryProgram(response.data.program_name);
        setActive_tab1(3);
      }
      // toastr.success(response.data.message);
      setLoading(false);
      setShowServiceHistoryMenu(true);
    }
    catch (error) {
      // alert(Active_tab1);
      // setActive_tab1( 2 );
      setLoading(false);
      setShowServiceHistoryMenu(true)
      // setNodata( error.response.data.message );
      toastr.error(error.response.data.message);
    }
  };

  // const downloadFile = () =>
  // {
  //   const link = document.createElement( 'a' );
  //   link.href = '/assets/Informasi-Program-Gratis-Biaya-Servis-Berkala.pdf';
  //   link.target = '_blank'; // Menentukan target sebagai _blank untuk membuka di tab baru
  //   document.body.appendChild( link );
  //   link.click();
  //   document.body.removeChild( link );
  // };

  // const goToRecommendation = () =>
  // {
  //   navigate( '/' );
  //   setTimeout( () =>
  //   {
  //     const recommendationSection = document.getElementById( 'recommendation-section' );
  //     if ( recommendationSection )
  //     {
  //       recommendationSection.scrollIntoView( { behavior: 'smooth' } );
  //     }
  //   }, 0 );
  // };

  // const handleCheckbox1Change = ( e ) =>
  // {
  //   setIsChecked1( e.target.checked );
  //   setShowModal( e.target.checked ); // Tampilkan modal ketika checkbox dicentang
  // };

  // const handleCheckbox2Change = () =>
  // {
  //   setIsChecked2( !isChecked2 );
  // };

  // const closeModal = () =>
  // {
  //   setShowModal( false );
  // };

  // Check if both checkboxes are checked
  // const isBothChecked = isChecked1 && isChecked2;

  // Fungsi untuk toggle visibilitas tabel
  // const toggleTableVisibility = () =>
  // {
  //   setIsTableVisible( ( prev ) => !prev );

  // };

  // const toggleTableVisibilityCoating = () =>
  // {
  //   setIsTableVisibleCoating( ( prev ) => !prev );
  // };

  // const getTabName = () =>
  // {
  //   switch ( activeTab1 )
  //   {
  //     case 0:
  //       return <strong>{ " " }{ programName }{ " " }</strong>;
  //     case 1:
  //       return <strong>{ " " }Warranty{ " " }</strong>;
  //     case 2:
  //       return <strong>{ " " }Coating{ " " }</strong>;
  //     default:
  //       return null;
  //   }
  // };

  const cars = [
    {
      name: "All New Vellfire Hybrid EV",
      type: "Hybrid EV",
      image: "/assets/hybrid-model/vellfire.png",
    },
    {
      name: "All New Alphard Hybrid EV",
      type: "Hybrid EV",
      image: "/assets/hybrid-model/alphard.png",
    },
    {
      name: "All New Kijang Innova Zenix Hybrid EV",
      type: "Hybrid EV",
      image: "/assets/hybrid-model/zenix.png",
    },
    {
      name: "All New Yaris Cross HEHybrid EVV",
      type: "Hybrid EV",
      image: "/assets/hybrid-model/yaris-cross.png",
    },
    {
      name: "All New BZ4X Battery EV",
      type: "Batter EV",
      image: "/assets/hybrid-model/bz4x.png",
    },
    {
      name: "New Corolla Cross Hybrid EV",
      type: "Hybrid EV",
      image: "/assets/hybrid-model/corolla-cross.png",
    },
    {
      name: "New Corolla Cross Hybrid EV GR Sport",
      type: "Hybrid EV",
      image: "/assets/hybrid-model/corolla-cross-gr-sport.png",
    },
    {
      name: "Hybrid EV",
      type: "Hybrid EV",
      image: "/assets/hybrid-model/camry.png",
    },
    {
      name: "New Corolla Altis Hybrid EV",
      type: "Hybrid EV",
      image: "/assets/hybrid-model/altis.png",
    }
  ];

  return (

    <div id="navbar_top">
      <Header headerTheme={'toyota-hybrid'}></Header>
      <StickyExploreButton showItem={[7,2,0,4]} stickyTheme={'hybrid-theme'} />
      <StickyLeftButton offerIndex={5} stickyTheme={'hybrid-theme'} />

      <div className="section-1 p-0 " id="section-1">
        <div>
          {/* <img
            src="/assets/hybrid-health-check-desktop-banner.jpg"
            className="d-block w-100"
            alt="Slide 1"
          /> */}
          <picture>
            <source media="(max-width:640px)" srcset="/assets/hybrid-health-check-mobile-banner.jpg" />
            <img src="/assets/hybrid-health-check-desktop-banner.jpg" alt="Toyota Hybrid Health Check" class="w-100" />
          </picture>
        </div>
      </div>

      <div className="container-fluid p-0 mt-5" id="hybridHealthCheckSection">
        <div id="evhcMainTab">
          <div className='container'>
            <ul className="nav nav-tabs custom-nav-tabs nav-fill custom-nav-fill ms-lg-0 ms-4 me-lg-0 me-4" style={{ border: 'none' }} role="tablist">
              <li className="nav-item custom-nav-item" role="presentation">
                <button
                  className={`nav-link custom-nav-link`}
                  id="faq_tab_1-tab"
                  onClick={() => {
                    // handleHHCMainTab('info')
                    navigate('/hybrid-health-check');
                  }}
                  data-bs-toggle="tab"
                  data-bs-target="#faq_tab_1"
                  type="button"
                  role="tab"
                  aria-controls="faq_tab_1"
                  aria-selected="true"
                >
                  <div className="d-flex flex-column lh-lg fw-bold menu-item">
                    <span>Hybrid Health Check Information</span>
                  </div>
                </button>
              </li>
              <li className="nav-item custom-nav-item" role="presentation">
                <button
                  className={`nav-link custom-nav-link active`}
                  id="faq_tab_2-tab"
                  onClick={() => {
                    // handleHHCMainTab('certificate')
                  }}
                  data-bs-toggle="tab"
                  data-bs-target="#faq_tab_2"
                  type="button"
                  role="tab"
                  aria-controls="faq_tab_2"
                  aria-selected="false"
                >
                  <div className="d-flex flex-column lh-lg fw-bold menu-item">
                    <span>Certificate Health Check</span>
                  </div>
                </button>
              </li>
            </ul>
          </div>
        </div>

        <div className="container px-lg-5">
          <div className="section-1 bg-white">
            <img src="/assets/toyota-hhc.png" className="hhc-logo w-75" alt="Toyota HHC Logo" />
          </div>
        </div>

        <div className="container px-lg-5">
          <div className="section-2 mt-5">
            <div className="row">
              <div class="col-lg-6 d-flex">
                <div class="section-content text-start my-auto">
                  <p className="Check">Check your</p>
                  <h1>Certificate & Service Record!</h1>
                  <p>
                    Cek nomor rangka kendaraan Anda dan dapatkan Sertifikat Elektronik untuk Hasil Pengecekan kesehatan Toyota Hybrid.
                  </p>
                </div>
              </div>

              {/* hhc seection */}
              <div className="col-lg-6 ">
                <ul className="nav nav-pills nav-fill">
                  <li className="nav-item">
                    <a className={`tabs sertifikat nav-link py-3 li_text_1 fw-bold ${activeTab === 0 ? "active" : ""}`} href="javascript:void(0)" onClick={() => handleTabClick(0)}>
                      {Active_tab1 !== 3 ? 'Sertifikat Elektronik' : 'Catatan Servis'}
                    </a>
                  </li>
                  {/* <li className="nav-item">
                    <a className={ `tabs cataten nav-link py-3 li_text_1 ${ activeTab === 1 ? "active" : "" }` } href="javascript:void(0)" onClick={ () => handleTabClick( 1 ) }>Catatan Servis</a>
                  </li> */}
                </ul>

                {/* seaech vin section */}
                <div style={{ display: loading ? "none" : activeTab === 0 ? "block" : "none", }}>
                  <div className="tabs-section" style={{ display: loading ? "none" : secondtab === 0 ? "block" : "none", }}>
                    <div class="circle-tab pt-4">
                      <a href="javascript:void(0)" className={`mx-3 active`}>
                        <img src="/assets/mdi_car-side_blue.png" alt="" />
                      </a>
                      <a href="javascript:void(0)" className={`mx-4`}>
                        <img src="/assets/Group (2).png" alt="" />
                      </a>
                      <a href="javascript:void(0)" className={`mx-3`}>
                        <img src="/assets/Group (3).png" alt="" />
                      </a>
                    </div>
                    <div>
                      <div className="d-md-flex justify-content-between mt-4 mx-4 text-start mx-md-5">
                        <p className="tab-bold-p">Validasi Nomor Rangka</p>
                        <p className="text-danger Langkah_side_text">
                          Langkah 1 - 3
                        </p>
                      </div>
                      <div className="tab-content mx-4 mx-md-5 text-start">
                        <p className="tab-light-bold-p">
                          Nomor Rangka kendaraan Anda dapat ditemukan pada STNK
                          atau BPKB kendaraan Anda
                        </p>
                      </div>
                      <div className="form-group mx-4 mx-md-5 ">
                        <input
                          type="text"
                          className="form-control Masukkan"
                          id="exampleInputEmail1"
                          aria-describedby="emailHelp"
                          placeholder="Masukkan 17 Digit No. Rangka Kendaraan"
                          value={vin}
                          onChange={handleInputChange}
                        />
                        <p className="mt-1 custom_wrong_chase text-start">
                          {WrongVin}
                        </p>
                      </div>
                      <button
                        className="btn btn-primary Lanjut mt-4 mb-4"
                        onClick={handleLanjutClick}
                      >
                        Lanjut
                      </button>
                    </div>
                  </div>
                </div>

                {/* info vin step-1 not register */}
                <div style={{ display: loading ? "none" : activeTab === 0 ? "block" : "none", }}>
                  <div className="tabs-section" style={{ display: loading ? "none" : secondtab === 1 ? "block" : "none", }}>
                    <div class="circle-tab pt-4">
                      <a
                        className={`mx-3 active cursor-pointer`}
                        onClick={() => handleregister(0)}
                      >
                        <img src="/assets/mdi_car-side_blue.png" alt="" />
                      </a>
                      <a href="javascript:void(0)" className={`mx-4 active`}>
                        <img src="/assets/Group (2).png" alt="" />
                      </a>
                      <a href="javascript:void(0)" className={`mx-3`}>
                        <img src="/assets/Group (3).png" alt="" />
                      </a>
                    </div>
                    <div>
                      <div className="d-md-flex justify-content-between mt-4 mx-4 text-start mx-md-5">
                        <p className="tab-bold-p">Validasi Nomor Rangka</p>
                        <p className="text-danger Langkah_side_text">
                          Langkah 2 - 3
                        </p>
                      </div>
                      <div>
                        <img src={imageUrl} className="img-extra mx-0 mt-2 " />
                        {/* <img src={ imageUrl2 } className="img-extra" /> */}
                        <p className="tab-bold-p">{vin}</p>
                      </div>
                      <div className="text-start mx-4 mx-md-5">
                        <p className="tab-bold" dangerouslySetInnerHTML={{ __html: tagline }} />
                        <p className="tab-bold" dangerouslySetInnerHTML={{ __html: description }} />
                        {/* <p className="tab-bold" dangerouslySetInnerHTML={ { __html: submission } } /> */}
                        <p style={{ color: "#03BFD7" }} className="mt-3">
                          {guideline}
                        </p>
                      </div>
                      <div className="mb-4">
                        <button
                          className="btn btn-primary Lanjut mt-4 ms-2"
                          onClick={() => handleregister(3)}
                        >
                          Lanjut
                        </button>
                      </div>
                    </div>
                  </div>
                </div>

                {/* info vin step-1 registered */}
                <div style={{ display: loading ? "none" : activeTab === 0 ? "block" : "none", }}>
                  <div className="tabs-section" style={{ display: loading ? "none" : secondtab === 2 ? "block" : "none", }}>
                    <div class="circle-tab pt-4">
                      <a
                        onClick={() => handleregister(0)}
                        className={`mx-3 active cursor-pointer`}
                      >
                        <img src="/assets/mdi_car-side_blue.png" alt="" />
                      </a>
                      <a href="javascript:void(0)" className={`mx-4 active`}>
                        <img src="/assets/Group (2).png" alt="" />
                      </a>
                      <a href="javascript:void(0)" className={`mx-3`}>
                        <img src="/assets/Group (3).png" alt="" />
                      </a>
                    </div>
                    <div>
                      <div className="d-md-flex justify-content-between mt-4 mx-4 text-start mx-md-5">
                        <p className="tab-bold-p">Validasi Nomor Rangka</p>
                        <p className="text-danger Langkah_side_text">
                          Langkah 2 - 3
                        </p>
                      </div>
                      <div>
                        <img src={imageUrl} className="img-extra m-0 mt-3" />
                        {/* <img src={ imageUrl2 } className="img-extra" /> */}
                        <p className="tab-bold-p">{vin}</p>
                      </div>
                      <div className="text-start mx-4 mx-md-5">
                        <p className="fw-bold" dangerouslySetInnerHTML={{ __html: info }} />
                        <p className="" dangerouslySetInnerHTML={{ __html: tagline }} />
                        <p className="" dangerouslySetInnerHTML={{ __html: description }} />
                        {/* <p className="tab-bold" dangerouslySetInnerHTML={ { __html: submission } } /> */}
                        <p style={{ color: "#03BFD7" }} className="mt-3">
                          Ingin ubah data diri anda? klik {" "}<span className="ubah_diri fw-bold" onClick={() => handleregister(3)}>disini</span>
                        </p>
                      </div>

                      <div className="mb-4">

                        <button
                          className="btn btn-primary Lanjut mt-4 ms-2"
                          onClick={() => {
                            handleregister(6);
                            // setShowCertificateMenu(false);
                            // setShowServiceHistoryMenu(true);
                          }}
                        >
                          Lanjut
                        </button>
                      </div>

                    </div>
                  </div>
                </div>

                <div style={{ display: loading ? "none" : activeTab === 0 ? "block" : "none", }} >
                  <div className="tabs-section" style={{ display: loading ? "none" : secondtab === 3 ? "block" : "none", }} >
                    <div class="circle-tab pt-4">
                      <a
                        onClick={() => handleregister(0)}
                        className={`mx-3 active cursor-pointer`}
                      >
                        <img src="/assets/mdi_car-side_blue.png" alt="" />
                      </a>
                      <a href="javascript:void(0)" className={`mx-4 active`}>
                        <img src="/assets/Group (2).png" alt="" />
                      </a>
                      <a href="javascript:void(0)" className={`mx-3`}>
                        <img src="/assets/Group (3).png" alt="" />
                      </a>
                    </div>
                    <div>
                      <div className="d-md-flex justify-content-between mt-4 mx-4 text-start mx-md-5">
                        <p className="tab-bold-p">Validasi Nomor Rangka</p>
                        <p className="text-danger Langkah_side_text">
                          Langkah 2 - 3
                        </p>
                      </div>
                      <div className="form-group mx-4 mx-md-5 text-start ">
                        <label className="input_label">Nama sesuai KTP</label>
                        <input
                          type="text"
                          className="form-control Masukkan"
                          id="exampleInputEmail1"
                          aria-describedby="emailHelp"
                          placeholder="Nama Lengkap"
                          autoComplete='off'
                          value={uname}
                          onChange={(e) => setName(e.target.value)}
                        />
                      </div>

                      <div className="form-group mx-4 mx-md-5 text-start">
                        <label className="input_label">
                          Bulan & Tahun kendaraan diterima oleh pelanggan
                        </label>
                        <div className="d-flex">
                          <div className="me-4 w-100">
                            <select
                              className="form-select"
                              aria-label="Select Month"
                              value={selectedMonth}
                              onChange={handleMonthChange}
                              style={{ border: "none" }}
                            >
                              <option value="" disabled hidden>Month</option>
                              {monthOptions.map(({ label, value }) => {
                                const currentYear = new Date().getFullYear();
                                const currentMonthIndex = new Date().getMonth() + 1; // 1..12
                                const selectedYearInt = parseInt(selectedYear || "0", 10);

                                // hanya tampilkan bulan yg valid s/d bulan berjalan di tahun berjalan
                                if (
                                  !selectedYear || // kalau tahun belum dipilih, tampilkan semua
                                  selectedYearInt < currentYear ||
                                  (selectedYearInt === currentYear && Number(value) <= currentMonthIndex)
                                ) {
                                  return (
                                    <option key={value} value={value}>
                                      {label}
                                    </option>
                                  );
                                }
                                return null;
                              })}
                            </select>
                          </div>
                          <div className="w-100">
                            <select
                              className="form-select"
                              aria-label="Select Year"
                              value={selectedYear}
                              onChange={handleYearChange}
                              style={{ border: "none" }}
                            >
                              {/* hapus attribute `selected` di option, karena controlled */}
                              {Array.from(
                                { length: new Date().getFullYear() - 1999 },
                                (_, index) => 2000 + index
                              ).map((y) => (
                                <option key={y} value={String(y)}>
                                  {y}
                                </option>
                              ))}
                            </select>
                          </div>
                        </div>
                      </div>

                      <div className="form-group mx-4 mx-md-5 text-start ">
                        <label className="input_label">Email</label>
                        <input
                          type="email"
                          className="form-control Masukkan"
                          placeholder="Email aktif"
                          autoComplete="off"
                          required
                          value={uemail}
                          onChange={(e) => {
                            setEmail(e.target.value);
                            setIsEmailChanged(true);
                          }}
                        />
                        {/* <span className='tiny-text'>Catatan : Masukkan Email aktif untuk mendapatkan program menarik dari Toyota</span> */}
                      </div>

                      {/* TODO: Agrement */}
                      <div className="col-12 agreement">
                        <div className="mb-4">
                          <div className="mt-2">
                            <table>
                              <tr>
                                <td style={ { width: "30px", verticalAlign: "middle" } }>
                                  <input
                                    type="checkbox"
                                    style={ { width: "20px" } }
                                    checked={ isChecked2 }
                                    onChange={ handleCheckbox2Change }
                                  />
                                </td>
                                <td style={ { textAlign: "justify" } }>
                                  Saya telah membaca dan menyetujui isi <a href='https://www.toyota.astra.co.id/privacy-policy' target='_blank'><span className='link-href'>kebijakan privasi Laman Situs Website Toyota</span></a> ini.
                                </td>
                              </tr>
                            </table>
                          </div>

                          <button
                            className="btn btn-primary Lanjut mt-4 ms-2"
                            onClick={submitData}
                            disabled={ !isChecked2 } // TODO: Enable when both checkboxes are checked
                          >
                            Lanjut
                          </button>
                        </div>
                      </div>

                    </div>
                  </div>
                </div>

                <div style={{ display: loading ? "none" : activeTab === 0 ? "block" : "none", }} >
                  <div className="tabs-section" style={{ display: loading ? "none" : secondtab === 4 ? "block" : "none", }}>
                    <div>
                      <div className="pt-4">
                        <img
                          src="/assets/icon-park-outline_info.svg"
                          className="img-fluid"
                        />
                        <p className="tab-bold-p pt-4">
                          Apakah data yang Anda masukkan sudah benar?
                        </p>
                      </div>
                      <div className="text-start mx-4 mx-md-5">
                        <div className="row">
                          <div className="col-4 p-0">
                            <span className="tab-light-bold-p1">Nama</span>
                          </div>
                          <div className="col-8 p-0">
                            <span className="tab-light-bold-p1">: {uname}</span>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-4 p-0">
                            <span className="tab-light-bold-p1">Email</span>
                          </div>
                          <div className="col-8 p-0">
                            <span className="tab-light-bold-p1">
                              : {isEmailChanged ? uemail : oldEmail}
                            </span>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-4 p-0">
                            <span className="tab-light-bold-p1">VIN</span>
                          </div>
                          <div className="col-8 p-0">
                            <span className="tab-light-bold-p1">: {vin}</span>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-4 p-0">
                            <span className="tab-light-bold-p1">Kendaraan</span>
                          </div>
                          <div className="col-8 p-0">
                            <span className="tab-light-bold-p1">
                              : {kendaraan}
                            </span>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-4 p-0">
                            <span className="tab-light-bold-p1">Warna</span>
                          </div>
                          <div className="col-8 p-0">
                            <span className="tab-light-bold-p1">: {warna}</span>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-4 p-0">
                            <span className="tab-light-bold-p1">
                              Bulan Penerimaan
                            </span>
                          </div>
                          <div className="col-8 p-0">
                            <span className="tab-light-bold-p1">
                              : {selectedMonth} {selectedYear}
                            </span>
                          </div>
                        </div>
                      </div>
                      <div className="mb-4">
                        <button
                          className="btn btn-primary lihat_Diri mt-4"
                          onClick={() => handleregister(3)}
                        >
                          Ubah Data Diri
                        </button>
                        <button
                          className="btn btn-primary Lanjut mt-4 ms-2"
                          onClick={submitRegister}
                        >
                          Lanjut
                        </button>
                      </div>
                    </div>
                  </div>
                </div>

                <div style={{ display: loading ? "none" : activeTab === 0 ? "block" : "none", }}>
                  <div className="tabs-section" style={{ display: loading ? "none" : secondtab === 5 ? "block" : "none", }} >
                    <div class="circle-tab pt-4">
                      <a
                        onClick={() => handleregister(0)}
                        className={`mx-3 active cursor-pointer`}
                      >
                        <img src="/assets/mdi_car-side_blue.png" alt="" />
                      </a>
                      <a href="javascript:void(0)" className={`mx-4 active`}>
                        <img src="/assets/Group (2).png" alt="" />
                      </a>
                      <a href="javascript:void(0)" className={`mx-3`}>
                        <img src="/assets/Group (3).png" alt="" />
                      </a>
                    </div>
                    <div>
                      <div className="d-md-flex justify-content-between mt-4 mx-4 text-start mx-md-5">
                        <p className="tab-bold-p">Verifikasi Email</p>
                        <p className="text-danger Langkah_side_text">
                          Langkah 2 - 3
                        </p>
                      </div>
                      <div className="form-group mx-4 mx-md-5 text-start d-flex justify-content-center py-4 ">
                        <input
                          type="text"
                          className="otp text-center"
                          id="otp1"
                          maxLength="1"
                          value={otp1}
                          onChange={(e) => {
                            setOtp1(e.target.value);
                            if (e.target.value === "") {
                              document.getElementById("otp1").focus();
                            } else if (e.target.value.length === 1) {
                              document.getElementById("otp2").focus();
                            }
                          }}
                          onKeyPress={(e) => {
                            // Allow only numbers to be entered
                            const isValidInput = /^\d*$/.test(e.key);
                            const isMaxLengthReached =
                              e.target.value.length >= 1;

                            if (!isValidInput || isMaxLengthReached) {
                              e.preventDefault();
                            }
                          }}
                        />
                        <input
                          type="text"
                          className="otp text-center"
                          id="otp2"
                          maxLength="1"
                          value={otp2}
                          onChange={(e) => {
                            setOtp2(e.target.value);
                            if (e.target.value === "") {
                              document.getElementById("otp1").focus();
                            } else if (e.target.value.length === 1) {
                              document.getElementById("otp3").focus();
                            }
                          }}
                          onKeyPress={(e) => {
                            // Allow only numbers to be entered
                            const isValidInput = /^\d*$/.test(e.key);
                            const isMaxLengthReached =
                              e.target.value.length >= 1;

                            if (!isValidInput || isMaxLengthReached) {
                              e.preventDefault();
                            }
                          }}
                        />
                        <input
                          type="text"
                          className="otp text-center"
                          id="otp3"
                          maxLength="1"
                          value={otp3}
                          onChange={(e) => {
                            setOtp3(e.target.value);
                            if (e.target.value === "") {
                              document.getElementById("otp2").focus();
                            } else if (e.target.value.length === 1) {
                              document.getElementById("otp4").focus();
                            }
                          }}
                          onKeyPress={(e) => {
                            // Allow only numbers to be entered
                            const isValidInput = /^\d*$/.test(e.key);
                            const isMaxLengthReached =
                              e.target.value.length >= 1;
                            if (!isValidInput || isMaxLengthReached) {
                              e.preventDefault();
                            }
                          }}
                        />
                        <input
                          type="text"
                          className="otp text-center"
                          id="otp4"
                          maxLength="1"
                          value={otp4}
                          onChange={(e) => {
                            setOtp4(e.target.value);
                            if (e.target.value === "") {
                              document.getElementById("otp3").focus();
                            } else if (e.target.value.length === 1) {
                              document.getElementById("otp5").focus();
                            }
                          }}
                          onKeyPress={(e) => {
                            // Allow only numbers to be entered
                            const isValidInput = /^\d*$/.test(e.key);
                            const isMaxLengthReached =
                              e.target.value.length >= 1;

                            if (!isValidInput || isMaxLengthReached) {
                              e.preventDefault();
                            }
                          }}
                        />
                        <input
                          type="text"
                          className="otp text-center"
                          id="otp5"
                          maxLength="1"
                          value={otp5}
                          onChange={(e) => {
                            setOtp5(e.target.value);
                            if (e.target.value === "") {
                              document.getElementById("otp4").focus();
                            } else if (e.target.value.length === 1) {
                              document.getElementById("otp6").focus();
                            }
                          }}
                          onKeyPress={(e) => {
                            // Allow only numbers to be entered
                            const isValidInput = /^\d*$/.test(e.key);
                            const isMaxLengthReached =
                              e.target.value.length >= 1;

                            if (!isValidInput || isMaxLengthReached) {
                              e.preventDefault();
                            }
                          }}
                        />
                        <input
                          type="text"
                          className="otp text-center"
                          id="otp6"
                          maxLength="1"
                          value={otp6}
                          onChange={(e) => {
                            setOtp6(e.target.value);
                            if (e.target.value === "") {
                              document.getElementById("otp5").focus();
                            }
                          }}
                          onKeyPress={(e) => {
                            // Allow only numbers to be entered
                            const isValidInput = /^\d*$/.test(e.key);
                            const isMaxLengthReached =
                              e.target.value.length >= 1;

                            if (!isValidInput || isMaxLengthReached) {
                              e.preventDefault();
                            }
                          }}
                        />
                      </div>
                      <p className="tab-light-bold-p1 mx-4 mx-md-5 text-start">
                        Silakan masukkan 6 digit kode OTP yang dikirimkan ke
                        email Anda.
                      </p>
                      <div className=" mx-4 mx-md-5 text-start d-flex">
                        <p className="tab-light-bold-p1">
                          Tidak menerima kode verifikasi? silakan{" "}
                        </p>
                        <p
                          className="text-danger tab-light-bold-p1"
                          style={{
                            display: timerValue != 0 ? "block" : "none",
                          }}
                        >
                          {" "}
                          &nbsp; klik di sini &nbsp;
                        </p>
                        <p
                          className="text-danger tab-light-bold-p1 cursor-pointer"
                          onClick={submitRegister}
                          style={{
                            display: timerValue === 0 ? "block" : "none",
                          }}
                        >
                          &nbsp; klik di sini &nbsp;
                        </p>
                        <p className="tab-light-bold-p1">00:{timerValue}</p>
                      </div>
                      <div className="mb-4">
                        <button
                          className="btn btn-primary Lanjut mt-4 ms-2"
                          onClick={submitOtp}
                        >
                          Lanjut
                        </button>
                      </div>
                    </div>
                  </div>
                </div>

                {/* download cert if registered */}
                {showCertificateMenu && (
                  <>
                    <div style={{ display: loading ? "none" : activeTab === 0 ? "block" : "none", }}>
                      <div className="tabs-section" style={{ display: loading ? "none" : secondtab === 6 ? "block" : "none", }}>
                        <div class="circle-tab pt-4">
                          <a
                            onClick={() => handleregister(0)}
                            className={`mx-3 active cursor-pointer`}
                          >
                            <img src="/assets/mdi_car-side_blue.png" alt="" />
                          </a>
                          {register === 2 && (
                            <a
                              onClick={() => handleregister(2)}
                              className={`mx-4 active cursor-pointer`}
                            >
                              <img src="/assets/Group (2).png" alt="" />
                            </a>
                          )}
                          {register === 1 && (
                            <a
                              onClick={() => handleregister(1)}
                              className={`mx-4 active cursor-pointer`}
                            >
                              <img src="/assets/Group (2).png" alt="" />
                            </a>
                          )}

                          <a href="javascript:void(0)" className={`mx-3 active`}>
                            <img src="/assets/Group (3).png" alt="" />
                          </a>
                        </div>

                        <div className="d-md-flex justify-content-between mt-4 mx-4 text-start mx-md-5">
                          <p></p>
                          <p className="text-danger Langkah_side_text">
                            Langkah 3 - 3
                          </p>
                        </div>

                        <div style={{ display: Active_tab1 !== 3 ? "block" : "none" }}>
                          <div className="form-group mx-4 mx-md-5 text-start pt-4 ">
                            <p className="custom_class_tab_discrip">
                              Masukkan email terdaftar untuk melihat riwayat servis kendaraan Anda:
                            </p>
                          </div>
                          <div className="form-group mx-4 mx-md-5 text-start">
                            <label className="input_label">Email</label>
                            <input
                              type="email"
                              className="form-control Masukkan"
                              id="exampleInputEmail1"
                              aria-describedby="emailHelp"
                              placeholder=""
                              value={emaill}
                              onChange={(e) => setEmaill(e.target.value)}
                            />
                          </div>

                          <div className="mb-4">
                            <button
                              className="btn btn-primary Lanjut mt-4 ms-2"
                              onClick={() => handleServiceHistory()}
                            >
                              Lanjut
                            </button>
                          </div>
                        </div>

                        <div class="card-body" style={{ display: loading ? "none" : Active_tab1 === 3 ? "block" : "none" }}>
                          <div className="text-start px-4 fw-bold mb-2 bk-program">
                            Catatan Servis Program <span className="text-blue-hybrid">{serviceHistoryProgram}</span>
                          </div>
                          <div className="table-responsive">
                            <table class="table mb-0">
                              <thead>
                                <tr>
                                  <th scope="col">Servis</th>
                                  <th scope="col">Tanggal Tes</th>
                                  <th scope="col">Cabang</th>
                                  <th scope="col">Status</th>
                                  <th scope="col">Sertifikat</th>
                                </tr>
                              </thead>
                              <tbody>
                                {tableData.map((rowData, index) => (
                                  <tr key={index} className="custom_border_tr">
                                    <td className="custom_border_set_td align-middle">Servis ke-{index + 1}</td>
                                    <td className="custom_border_set_td align-middle">{rowData.report_date ?? "-"}</td>
                                    <td className="custom_border_set_td align-middle">{rowData.outlet}</td>
                                    <td className="custom_border_set_td align-middle">
                                      {rowData.health_check_summary ? (
                                        <span class="text-success">Good</span>
                                      ) : (
                                        <span class="text-danger">Not Good</span>
                                      )}
                                    </td>
                                    <td className="custom_border_set_td align-middle">
                                      <a class="btn btn-sm btn-warning rounded-pill" role="button" target="_blank" href={rowData.certificate_path}>Download</a>
                                    </td>
                                  </tr>
                                ))}
                              </tbody>
                            </table>
                          </div>
                        </div>

                        <div className="mb-4">
                          <button
                            className="btn btn-primary lihat_Diri_2 mt-4"
                            onClick={() => goBack(1)}
                          >
                            Kembali ke Halaman Awal
                          </button>
                        </div>

                      </div>
                    </div>
                  </>
                )}

                {loading && (
                  <div className="spinner-overlay add_custom_properties">
                    <Oval
                      height="60"
                      width="60"
                      radius="9"
                      color="black"
                      ariaLabel="three-dots-loading"
                      secondaryColor="grey"
                      wrapperStyle={{ marginTop: "10%", marginBottom: "10%" }}
                    />
                  </div>
                )}

                {/* service history */}
                {/* {showServiceHistoryMenu && (
                  <>
                    <div style={{display: loading ? "none" : "block" }} >
                      {Active_tab1 !== 3 && (
                        <>
                          <div className="tabs-section">
                            <div>
                              <div className="form-group mx-4 mx-md-5 text-start pt-4 ">
                                <p className="custom_class_tab_discrip">
                                  Masukkan email terdaftar untuk melihat riwayat servis kendaraan Anda:
                                </p>
                              </div>
                              <div className="form-group mx-4 mx-md-5 text-start">
                                <label className="input_label">Email</label>
                                <input
                                  type="email"
                                  className="form-control Masukkan"
                                  id="exampleInputEmail1"
                                  aria-describedby="emailHelp"
                                  placeholder=""
                                  value={ emaill }
                                  onChange={ ( e ) => setEmaill( e.target.value ) }
                                />
                              </div>
                              <div className="form-group mx-4 mx-md-5 text-start">
                              </div>

                              <div className="mb-4">
                                <button
                                  className="btn btn-primary Lanjut mt-4 ms-2"
                                  onClick={() => handleServiceHistory() }
                                >
                                  Lanjut
                                </button>
                              </div>
                            </div>
                          </div>
                          <div
                            className="tabs-section"
                            style={ {
                              display: loading
                                ? "none"
                                : Active_tab1 === 2
                                  ? "block"
                                  : "none",
                            } }
                          >
                            <div>
                              <div className="pt-4">
                                <img
                                  src="/assets/icon-park-outline_info.svg"
                                  className="img-fluid"
                                />
                                <p className="tab-discription-p pt-4 px-4">{ Nodata }</p>
                              </div>
                              <div className="mb-4">
                                <button
                                  className="btn btn-primary Lanjut mt-4 ms-2"
                                  onClick={ () => goBack( 1 ) }
                                >
                                  Kembali
                                </button>
                              </div>
                            </div>
                          </div>
                        </>
                      )}
                    </div>
                  </>
                )}   */}
              </div>
            </div>

            {/* recomend section */}
            {/* <div className='container container-recommend'>
              <div className="row mt-5">
                <span className="recommend-section">
                  Cek rekomendasi produk tambahan untuk servis T-CARE Anda!
                </span>
                <div>
                  <button
                    className="btn custom-btn-dark me-3 mt-4 ms-2"
                    onClick={ goToRecommendation }
                  >
                    Go to recommendation
                  </button>
                </div>
              </div>
            </div> */}

          </div >
        </div>

        <div className="container p-lg-5 mt-5">
          <h2 className="fw-bold">
            Lihat hal-hal yang sering ditanyakan
          </h2>
          <div className="mt-5">
            <NavLink to="/faq" className="btn custom-btn-hybrid fw-bold px-3 py-2">
              Go to FAQ Page
            </NavLink>
          </div>
        </div>

        <div className="container mt-3 mb-5">
          <div className="logos d-flex justify-content-center mt-3 mb-4">
            <div className="bottom-logo mx-2">
              <img src="/assets/quality-service.png" alt="t-care-img" />
            </div>
            <div className="bottom-logo mx-2">
              <img src="/assets/genuine-parts (1).png" alt="t-care-img" />
            </div>
            <div className="bottom-logo mx-2">
              <img src="/assets/itfe.png" alt="itfe-img" />
            </div>
          </div>
        </div>

      </div>
      <AftersalesExploreService showItem={[0,1,2,3,5,6]} />
      <Footer footerTheme={'toyota-hybrid'}></Footer>
    </div>
  );
}

export default EVHC;
